module.exports = __webpack_public_path__ + "img/Dantam Hair 50.c973df02.jpg";